import { render } from "./component-es-id.vue?vue&type=template&id=770ed53d"
import script from "./component-es-id.vue?vue&type=script&setup=true&lang=js"
export * from "./component-es-id.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-es-id.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "770ed53d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('770ed53d', __exports__)) {
    api.reload('770ed53d', __exports__)
  }
  
  module.hot.accept("./component-es-id.vue?vue&type=template&id=770ed53d", () => {
    api.rerender('770ed53d', render)
  })

}


export default __exports__